<div class="loginRegisterScreen">
  <button class="vc-dialog__closeBtn" [mat-dialog-close]>
    <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
    <vc-sprite-icons name="cross-x-thick" class="vc-dialog__closeBtn__icon"></vc-sprite-icons>
  </button>
  <div class="loginRegisterScreen__visual">
    <img class="loginRegisterScreen__visual__logo" src="/assets/img/home/vestiairecollective_logo.svg?v=1" />
  </div>
  <div class="loginRegisterScreen__content">
    <div class="loginRegisterScreen__content__title" i18n="@@LOGIN.TEXT.YOU_WANT_IN">You want in ?</div>
    <div class="loginRegisterScreen__content__options">
      <div class="loginRegisterScreen__content__options__list">
        <vc-sprite-icons name="check-in-case" class="loginRegisterScreen__content__options__list__checkbox">
        </vc-sprite-icons>
        <label class="loginRegisterScreen__content__options__list__label" i18n="@@LOGIN.TEXT.FIND_DEALS"
          >Find Deals</label
        >
      </div>
      <div class="loginRegisterScreen__content__options__list">
        <vc-sprite-icons name="check-in-case" class="loginRegisterScreen__content__options__list__checkbox">
        </vc-sprite-icons>
        <label class="loginRegisterScreen__content__options__list__label" i18n="@@LOGIN.TEXT.MAKE_OFFERS"
          >Make Offers</label
        >
      </div>
      <div class="loginRegisterScreen__content__options__list">
        <vc-sprite-icons name="check-in-case" class="loginRegisterScreen__content__options__list__checkbox">
        </vc-sprite-icons>
        <label class="loginRegisterScreen__content__options__list__label" i18n="@@LOGIN.TEXT.BUY_SELL_BETTER"
          >Buy and Sell Better</label
        >
      </div>
    </div>
    <div class="loginRegisterScreen__content__actions">
      <button
        class="loginRegisterScreen__content__actions__button vc-btn vc-btn--full vc-btn--medium vc-btn--secondary"
        (click)="this.switchTo('register')"
        i18n="@@LOGIN.FIRST_SCREEN.REGISTER"
      >
        Sign up
      </button>
      <button
        class="loginRegisterScreen__content__actions__button vc-btn vc-btn--full vc-btn--medium vc-btn--primary"
        (click)="this.switchTo('login')"
        i18n="@@LOGIN.FIRST_SCREEN.LOGIN"
      >
        Log in
      </button>
    </div>
  </div>
</div>
